import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import { showModal } from 'actions/modal';

import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

import Popout from 'components/popout';
import CustomFieldSelector from 'components/CustomFieldSelector';

import IconClose from 'icons/icon-close';

class SelectCustomFieldPopout extends PureComponent {
    static contextType = RolesAndPermissionsContext;

    static defaultProps = {
        excluded: []
    }
    state = {
        popoutVisible: false,
        searchTerm: ''
    };

    handlePopoutOpenClick = () => {
        this.show();
    }

    handlePopoutCloseClick = () => {
        this.hide();
    }

    handlePopoutShow = () => {
        this.setState({
            popoutVisible: true
        });

        this.props.onShow && this.props.onShow();
    }

    handlePopoutHide = () => {
        this.setState({
            popoutVisible: false
        });
        this.props.onHide && this.props.onHide();
    }

    handleCustomFieldSelect = id => {
        this.props.onSelect(id);

        this.hide();
    }

    // handleCreateMilestoneClick = () => {
    //     showModal('MILESTONE_CREATE', {
    //         projectId: this.props.projectId,
    //         milestones: this.props.milestones,
    //         onCreate: id => {
    //             this.props.onSelect(id);
    //         }
    //     });

    //     this.hide();

    //     this.props.onCreate && this.props.onCreate();
    // }

    show() {
        this.popoutCtrl && this.popoutCtrl.show();
    }

    hide() {
        this.popoutCtrl && this.popoutCtrl.hide();
    }

    setPopoutCtrl = ctrl => this.popoutCtrl = ctrl;

    componentDidMount() {
        const { provideController } = this.props;
        const ctrl = {
            show: () => this.show(),
            hide: () => this.hide()
        };

        if (provideController) {
            if ('current' in provideController) {
                provideController.current = ctrl;
            } else {
                provideController && provideController(ctrl);
            }
        }
    }

    componentWillUnmount() {
        const { provideController } = this.props;

        if (provideController) {
            if ('current' in provideController) {
                provideController.current = null;
            } else {
                provideController && provideController(null);
            }
        }
    }

    render() {
        const { t } = this.props;

        // TODO: Add content loader
        const children = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                className: child.props.className + (this.state.popoutVisible ? ' selected disable-tooltip' : ''),
                onClick: this.handlePopoutOpenClick
            });
        });

        return (
            <React.Fragment>
                { children }

                <Popout
                    className="no-arrow xxsmall"
                    provideController={this.setPopoutCtrl}
                    onShow={this.handlePopoutShow}
                    onHide={this.handlePopoutHide}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    closeOnEveryClick={true}
                    inline={this.props.inline}
                >
                    <div className="popout-head">
                        { this.props.title }

                        <button className="btn btn-icon btn-small popout-close" onClick={this.handlePopoutCloseClick}>
                            <IconClose />
                        </button>
                    </div>

                    <div className="popout-main">
                        <CustomFieldSelector
                            projectId={this.props.projectId}
                            association={this.props.association}
                            selected={this.props.selected}
                            onSelect={this.handleCustomFieldSelect}
                            excluded={this.props.excluded}
                            // resourceCreateText={ t('Create a milestone') }
                            // onResourceCreate={this.props.showCreate && this.context?.canUser('createMilestone') && this.handleCreateMilestoneClick}
                        />
                    </div>
                </Popout>
            </React.Fragment>
        );
    }
}

export default withTranslation('milestone')(SelectCustomFieldPopout);
